// extracted by mini-css-extract-plugin
export default {"container":"list_container__AMVNC","item":"list_item__elrYd","item_container":"list_item_container__tx2tH","item_logo":"list_item_logo__a2a+n"};